import { api } from "@/services/api";

/**
 * Store de Salones de Acceso General (Sprint 57 · F4A).
 *
 * Fuente de verdad: backend (endpoints F2). Cada operación persiste en el
 * servidor; no se conserva configuración importante sólo en estado local.
 * Devuelve `{ error }` en fallo (nunca lanza) para que la UI muestre mensajes
 * consistentes con el resto del administrador.
 */

const _err = (e) => ({
  error: e?.response?.data?.detail || "network",
  status: e?.response?.status,
});

export const listarSalonesAcceso = async (eventoId) => {
  if (!eventoId) return [];
  try {
    const { data } = await api.get(`/eventos/${eventoId}/salones-acceso`);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

export const crearSalonAcceso = async (eventoId, payload) => {
  try {
    const { data } = await api.post(`/eventos/${eventoId}/salones-acceso`, payload);
    return data;
  } catch (e) {
    return _err(e);
  }
};

export const actualizarSalonAcceso = async (eventoId, salonId, payload) => {
  try {
    const { data } = await api.put(
      `/eventos/${eventoId}/salones-acceso/${salonId}`,
      payload,
    );
    return data;
  } catch (e) {
    return _err(e);
  }
};

export const activarSalonAcceso = async (eventoId, salonId) => {
  try {
    const { data } = await api.post(
      `/eventos/${eventoId}/salones-acceso/${salonId}/activar`,
    );
    return data;
  } catch (e) {
    return _err(e);
  }
};

export const desactivarSalonAcceso = async (eventoId, salonId) => {
  try {
    const { data } = await api.post(
      `/eventos/${eventoId}/salones-acceso/${salonId}/desactivar`,
    );
    return data;
  } catch (e) {
    return _err(e);
  }
};

export const eliminarSalonAcceso = async (eventoId, salonId) => {
  try {
    const { data } = await api.delete(
      `/eventos/${eventoId}/salones-acceso/${salonId}`,
    );
    return data;
  } catch (e) {
    return _err(e);
  }
};

/** Ordena visualmente por `orden` y luego por `id` (misma regla del backend). */
export const ordenarSalones = (salones) =>
  (Array.isArray(salones) ? salones.slice() : []).sort((a, b) => {
    const o = (a.orden ?? 0) - (b.orden ?? 0);
    return o !== 0 ? o : String(a.id).localeCompare(String(b.id));
  });

/** Resumen para checklist / vista de venta (sólo cuenta activos). */
export const resumenSalonesAcceso = (salones) => {
  const arr = Array.isArray(salones) ? salones : [];
  const activos = arr.filter((s) => s.activo);
  return {
    totalSalones: arr.length,
    salonesActivos: activos.length,
    capacidadTotalActiva: activos.reduce(
      (sum, s) => sum + (Number(s.capacidad) || 0),
      0,
    ),
    todosActivosConCapacidad:
      activos.length > 0 && activos.every((s) => Number(s.capacidad) > 0),
    todosActivosConPrecio:
      activos.length > 0 && activos.every((s) => Number(s.precioPorBoleto) > 0),
  };
};
